import React, { useState } from 'react';
import { Form, Input, Select } from 'antd';
import { FormField } from 'components/common/forms';
import { getOptionItems } from 'helpers/getOptionItems';
import { DiscountPayload } from 'services/interfaces/DiscountPayload';
import { Discount, Reservation } from 'models';
import { useLookups } from 'hooks/useLookups';
import useMount from 'hooks/useMount';

type Props = {
  rateId: string;
  reservation: Reservation;
  onChange: (value: Discount) => void;
}
const DiscountSection: React.FC<Props> = ({ rateId, reservation, onChange }) => {
  const fields = Discount.Model.fields;
  const lookups = useLookups();
  const form = Form.useFormInstance<Discount>();
  const [discounts, setDiscounts] = useState<DiscountPayload[]>([]);
  const [discount, setDiscount] = useState<DiscountPayload>();
  const discountOps = getOptionItems(discounts, x => x.name);
  const discountType = discount?.type;

  const updateDiscount = (discount: DiscountPayload) => {
    if (discount && discount.type === 'loyalty') {
      fields.loyaltyNumber.label = discount.loyaltyNumberLabel;
    }
    setDiscount(discount);
  };

  const fetchData = async () => {
    const rate = lookups.rates.find(x => x.id === rateId);
    if (rate?.discountIds.length > 0) {
      const discounts = lookups.discounts.filter(x => rate.discountIds.includes(x.id));
      setDiscounts(discounts);
      form.setFieldsValue({
        discountId: reservation.discountId,
        discountCode: reservation.discountCode,
        loyaltyNumber: reservation.loyaltyNumber,
      });
      const discount = discounts.find(x => x.id === reservation.discountId);
      updateDiscount(discount);
    }
  };

  useMount(() => {
    if (rateId) fetchData();
  });

  const onSelectChange = (discountId: string) => {
    const discount = discounts.find(x => x.id === discountId);
    updateDiscount(discount);
    if (!discountId) {
      const discountModel = Discount.new({ discountId: null });
      form.setFieldsValue(discountModel);
      onChange && onChange(discountModel);
    }
  }

  const onBlur = () => {
    const discount = form.getFieldsValue();
    onChange && onChange(discount);
  }

  return (
    <>
      <FormField field={fields.discountId}>
        <Select options={discountOps} allowClear disabled={!discountOps.length} onChange={onSelectChange} />
      </FormField>
      {discountType === 'loyalty' && (
        <FormField field={fields.loyaltyNumber}>
          <Input onBlur={onBlur} />
        </FormField>
      )}
      {discountType === 'code' && (
        <FormField field={fields.discountCode}>
          <Input onBlur={onBlur} />
        </FormField>
      )}
    </>
  );
};

export default DiscountSection;
